import HigiaAuthService from '@/servicesTS/HigiaAuthService'
import privilegios from '@/helpers/privilegios'
import utils from '@/helpers/utils'

const routeAccess = (to: any, _: any, next: any) => {
    const higiaAuthService = new HigiaAuthService()

    if (to.meta.requiresAuth) {
        if (
            !higiaAuthService.sessionIsExpired() &&
            higiaAuthService.isAuthenticated() &&
            privilegios.temPrivilegioFn(to)
        ) {
            _nextRoute(to, next)
        } else {
            _next(to, next)
        }
    } else {
        _nextRoute(to, next)
    }
}

const _next = (_: any, next: any) => {
    next()
}

const _nextRoute = (to: any, next: any) => {
    if (to.name != 'errHigia') {
        utils.setBackgroundBody(to.name)
    }
    if (to.name == 'login') {
        _next(to, next)
    } else {
        next()
    }
}

export default {
    routeAccess,
}
